import { CheckboxQuestion, DatePickerQuestion, DropdownQuestion, max, min, MultiselectQuestion } from "@ot/shared/questions";
import { LocalDate } from 'js-joda';
import { Jurisdictions } from '../constants';
import { FiltersService } from './filters.service';
import * as i0 from "@angular/core";
import * as i1 from "./filters.service";
export class FilterQuestionsService {
    constructor(filtersService) {
        this.filtersService = filtersService;
    }
    createStartDateQuestion(options) {
        const defaultQuestionOptions = {
            key: 'startDate',
            label: 'Start Date',
            value: this.filtersService.getDefaultStartDate(),
            required: true,
            dateAfterOther: 'endDate',
            dateRangeDate: 'endDate',
            dateRangeLimit: 365,
            validators: [min(LocalDate.now().minusYears(9)), max(LocalDate.now())]
        };
        return new DatePickerQuestion(Object.assign({}, defaultQuestionOptions, Object.assign({}, options, { value: options.value || defaultQuestionOptions.value })));
    }
    createEndDateQuestion(options) {
        const defaultQuestionOptions = {
            key: 'endDate',
            label: 'End Date',
            required: true,
            dateAfterOther: 'startDate',
            dateRangeDate: 'startDate',
            validators: [max(LocalDate.now())]
        };
        return new DatePickerQuestion(Object.assign({}, defaultQuestionOptions, Object.assign({}, options, { value: options.value || defaultQuestionOptions.value })));
    }
    createTaxAccountQuestion(taxAccounts, options) {
        const defaultQuestionOptions = {
            key: 'taxAccount',
            label: 'Tax Account',
            readonly: false,
            columnClass: 'is-full',
            options: [
                { value: 'Any', key: '' },
                {
                    value: 'Unassigned',
                    key: 'unassigned'
                }
            ].concat(taxAccounts.map(taxAccount => ({
                key: taxAccount.id.value,
                value: taxAccount.companyName
            })))
        };
        return new DropdownQuestion(Object.assign({}, defaultQuestionOptions, options));
    }
    createVehicleQuestion(vehicles, options) {
        const defaultQuestionOptions = {
            key: 'vehicles',
            label: 'Vehicles',
            readonly: false,
            order: 1,
            columnClass: 'is-full',
            required: true,
            options: vehicles,
            selectAllLabel: 'All Vehicles',
            noResultsLabel: 'No vehicles found.',
            keyMapper: vehicle => vehicle.id,
            labelMapper: vehicle => vehicle.customId,
            valueMapper: totalItems => `${totalItems} vehicles selected`
        };
        return new MultiselectQuestion(Object.assign({}, defaultQuestionOptions, options));
    }
    createJurisdictionQuestion(options) {
        const defaultQuestionOptions = {
            key: 'jurisdictions',
            label: 'Jurisdiction',
            readonly: false,
            order: 2,
            columnClass: 'is-full',
            required: true,
            options: Object.keys(Jurisdictions),
            selectAllLabel: 'All Jurisdictions',
            noResultsLabel: 'No jurisdictions found.',
            keyMapper: jurisdiction => jurisdiction,
            labelMapper: jurisdiction => Jurisdictions[jurisdiction],
            valueMapper: totalItems => `${totalItems} jurisdictions selected`
        };
        return new MultiselectQuestion(Object.assign({}, defaultQuestionOptions, options));
    }
    createUserReviewRequiredQuestion(options) {
        const defaultQuestionOptions = {
            key: 'userReview',
            label: 'User Review Required',
            value: options.value,
            columnClass: 'is-full',
            order: 3,
            isValid: true
        };
        return new CheckboxQuestion(Object.assign({}, defaultQuestionOptions, options));
    }
}
FilterQuestionsService.ngInjectableDef = i0.defineInjectable({ factory: function FilterQuestionsService_Factory() { return new FilterQuestionsService(i0.inject(i1.FiltersService)); }, token: FilterQuestionsService, providedIn: "root" });
